import { exchangeOptions } from 'config/filterTypes';

export const SET_SELECTED_SYMBOLS = 'WATCHLIST_DIALOG/SET_SELECTED_SYMBOLS';
export const SET_SELECTED_EXCHANGE_ID = 'WATCHLIST_DIALOG/SET_SELECTED_EXCHANGE_ID';
export const RESET_ALL_WATCHLIST_DIALOG_STATES = 'WATCHLIST_DIALOG/RESET_ALL_WATCHLIST_DIALOG_STATES';
export const IS_GET_FRESH_WATCHLIST_CATEGORIES_DATA = 'WATCHLIST_DIALOG/IS_GET_FRESH_WATCHLIST_CATEGORIES_DATA';

export const setSelectedSymbols = selectedSymbols => ({
  type: SET_SELECTED_SYMBOLS,
  selectedSymbols,
});
export const setSelectedExchangeId = selectedExchangeOption => ({
  type: SET_SELECTED_EXCHANGE_ID,
  selectedExchangeOption,
});
export const setIsGetFreshWatchlistCategoriesData = isGetFreshWatchlistCategoriesData => ({
  type: IS_GET_FRESH_WATCHLIST_CATEGORIES_DATA,
  isGetFreshWatchlistCategoriesData,
});
export const resetAllWatchlistDialogStates = () => ({
  type: RESET_ALL_WATCHLIST_DIALOG_STATES,
});

const getDefaultState = () => {
  return {
    selectedSymbols: [],
    selectedExchangeOption: exchangeOptions[0],
    isGetFreshWatchlistCategoriesData: false,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_SELECTED_SYMBOLS:
      return { ...state, selectedSymbols: action.selectedSymbols };
    case SET_SELECTED_EXCHANGE_ID:
      return { ...state, selectedExchangeOption: action.selectedExchangeOption };
    case IS_GET_FRESH_WATCHLIST_CATEGORIES_DATA: {
      return { ...state, isGetFreshWatchlistCategoriesData: action.isGetFreshWatchlistCategoriesData };
    }
    case RESET_ALL_WATCHLIST_DIALOG_STATES:
      return { ...getDefaultState() };

    default:
      break;
  }
  return state;
}
